import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { AppLayout } from "layout";
import { CheckOutData } from "modules/CartCheckOut/components";

type Props = {};
// Ensure the key exists
const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
// const stripePublicKey = "pk_test_51QeK6dL0I44ZCFPV0kDOLGzjutPCJOhrjloKbPUtAKPPJbabyqt5ZbqS0siLRDP8qAd7W9hWNkUm5eqXsjBhCaQ700190fqevP";

if (!stripePublicKey) {
  throw new Error("Stripe public key is missing. Check your .env file.");
}

const stripePromise = loadStripe(stripePublicKey);

const CheckOutContainer = (props: Props) => {
  return (
    <AppLayout>
      <Elements stripe={stripePromise}>
        <CheckOutData />
      </Elements>
    </AppLayout>
  );
};

export default CheckOutContainer;
